import * as React from 'react';
import capitalize from 'react-bootstrap/lib/utils/capitalize';
import { ErrorMessage, Field } from 'formik';
import style from '@magoosh/lib/formik_inputs/field_input/style.module.scss';
import DropdownList from 'react-widgets/lib/DropdownList';

interface FieldDropdownListProps {
  name: string;
  id?: string;
  data?: any[];
  valueField?: string;
  textField?: string | ((dataItem?) => string);
  defaultValue: any;
  label?: string;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  filter?: string;
  groupBy?: string | ((any) => any);
}

export class FieldDropdownList extends React.Component<FieldDropdownListProps> {
  render() {
    const props = this.props;

    return (
      <div className="u-margin-T-s">
        <label htmlFor={id(props)}>{capitalize(props.label || props.name)}</label>

        <Field name="classSectionId">
          {({ field, form, meta }) => (
            <DropdownList
              {...props}
              onChange={(value) =>
                form.setFieldValue(props.name, props.valueField ? value[props.valueField] : value)
              }
            />
          )}
        </Field>
        <div className={style.errorMessage}>
          <ErrorMessage name={props.name} />
        </div>
      </div>
    );
  }
}

function id(props: FieldDropdownListProps) {
  return props.id || `${props.name}-input`;
}
